
export const formFields = {
    gamCurrency: {
        key: 'gamCurrency',
        label: 'Currency',
        placeholder: '',
        type: "text",
        displayLayout: 'col-md-7',
        valueKey: 'key',
        required: true,
        requiredMessage: 'This field  is required.',
        textKey: 'value',
        tooltip: '<div> Currency </div>',
        pattern: /^[A-Z]*$/
      },
      gamAccountID: {
        key: 'gamAccountID',
        label: 'Account ID',
        placeholder: '',
        required: true,
        requiredMessage: 'This field is required.',
        maxLength: 100,
        maxLengthMessage: 'maximum 100 characters allowed.',
        displayLayout: 'col-md-7',
        tooltip: '<div> Account ID </div>',
        pattern: /^\d{0,100}$/
      },
}